import Icon from 'assets/components/icon/Icon';
import { usePublicCreateClaimProvider } from '../Hooks';
import Theme from 'assets/themes/Theme.Common';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import { getLocales } from 'assets/locales/Locale';

export default function PublicCreateClaimFinish() {
  const publicCreateClaim = usePublicCreateClaimProvider();
  const { lang } = getLocales();
  return (
    <>
      {!publicCreateClaim.form.isFinished ? (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <Icon class="fas-spinner fa-spin" style={{ fontSize: Theme.FontSize.XXL }} />

          <h2>{lang.savingYourClaim}...</h2>
          <p>{lang.saveClaimPleaseWait}.</p>
        </div>
      ) : (
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <Icon class="fas-check-circle" style={{ fontSize: Theme.FontSize.XXL, color: Theme.Color.success }} />

          <h2>{lang.thankYou}!</h2>
          <p>{lang.publicClaimFinishSuccess}.</p>
          <Button
            onClick={() => location.reload()}
            class={ThemeButtonCircle}
            render={`${lang.addNew} ${lang.claim}`}
            media={<Icon class="fas-plus" />}
            active
            htmlElementProps={{ title: `${lang.addNew} ${lang.claim}` }}
          />
        </div>
      )}
    </>
  );
}
